module.exports = __webpack_public_path__ + "img/手与花装饰-1.7e9621a0.jpg";